import styled from "@emotion/styled";
import TimezoneConverter from "components/TimeZoneConvertor";
import { useSelector } from "react-redux";
import { formatDate } from "utils/helper";

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  // width: 200px;
  margin-left: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  font-size: 12px;
`;

const Label = styled.p`
  font-weight: bold;
  margin: 0;
  opacity: 0.7;
`;

const Value = styled.span`
  margin-left: 8px;
  color: #278000;
  font-weight: bold;
`;

const OccupantInformationCard = () => {
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || {}
  );

  return (
    <CardContainer>
      {currentOccupant?.tenantReleaseDate && (
        <InfoRow>
          <Label>Released:</Label>
          <Value>
            {formatDate(
              (
                <TimezoneConverter
                  time={currentOccupant?.tenantReleaseDate || "N/A"}
                />
              ).props.time
            )}
          </Value>
        </InfoRow>
      )}

      {currentOccupant?.boPeriod && (
        <InfoRow>
          <Label>BO Period:</Label>
          <Value>{currentOccupant?.boPeriod || "N/A"}</Value>
        </InfoRow>
      )}

      {currentOccupant?.boEndDate && (
        <InfoRow>
          <Label>BO Date:</Label>
          <Value>{currentOccupant?.boEndDate || "N/A"}</Value>
        </InfoRow>
      )}

      {currentOccupant?.ORSIssuedDate && (
        <InfoRow>
          <Label>ORS Issued:</Label>
          <Value>
            {formatDate(
              (
                <TimezoneConverter
                  time={currentOccupant?.ORSIssuedDate || "N/A"}
                />
              ).props.time
            )}
            {/* {currentOccupant?.ORSIssuedDate || "N/A"} */}
          </Value>
        </InfoRow>
      )}
    </CardContainer>
  );
};

export default OccupantInformationCard;
